module.exports = __webpack_public_path__ + "img/dg-browse-vehicles-nissan.27711265.png";